import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { formatDateRange, parseDateRangeFromLabel, formatDateForAPI } from "../../../Helper/Analytics/AnalyticsHelper";
import { usePagesContent } from "../../../Hooks/usePagesContent";
import AutoResolvedChartView from "./AutoResolvedChartView";
import AutoResolvedDrillDownModal from "./AutoResolvedDrillDownModal";
import { CHART_TYPES } from "./chartConfig";

const AutoResolvedChart = ({ onDetailsClick, startDate, endDate, globalFilters }) => {
  const pagesContent = usePagesContent();
  const [drillDownOpen, setDrillDownOpen]       = useState(false);
  const [selectedDataPoint, setSelectedDataPoint] = useState(null);
  const [drillDownDates, setDrillDownDates]       = useState({ startDate: null, endDate: null });

  const chartMeta = pagesContent?.metaInfo?.charts?.[CHART_TYPES.AUTO_RESOLVED];

  if (!pagesContent?.mounted || chartMeta?.enabled === false) return null;

  const title = chartMeta?.title || "Alert Resolution Trend (Auto vs Manual)";

  const handleBarClick = (dataPoint) => {
    const { startDate: clickedStart, endDate: clickedEnd } = parseDateRangeFromLabel(
      dataPoint.originalDateRange, startDate, endDate
    );
    setDrillDownDates({
      startDate: formatDateForAPI(clickedStart) || startDate,
      endDate:   formatDateForAPI(clickedEnd)   || endDate,
    });
    setSelectedDataPoint(dataPoint);
    setDrillDownOpen(true);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        padding: "24px 22px",
        border: "1px solid #E6E6E6",
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography variant="fw600s16lh24c444B51" sx={{ color: "#2E2E2E" }}>
            {title}
          </Typography>
          {onDetailsClick && (
            <Box
              onClick={onDetailsClick}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                "&:hover": {
                  "& .MuiTypography-root": { color: "#4D44D8" },
                  "& .MuiSvgIcon-root":    { color: "#4D44D8" },
                },
              }}
            >
              <Typography variant="fw500s12lh20c000000" sx={{ color: "#6D72F6" }}>
                Details
              </Typography>
              <ChevronRightIcon sx={{ color: "#6D72F6", fontSize: "18px" }} />
            </Box>
          )}
        </Box>
        <Typography variant="fw400s12c686868" sx={{ lineHeight: "20px" }}>
          {formatDateRange(startDate, endDate)}
        </Typography>
      </Box>

      {/* Chart */}
      <AutoResolvedChartView
        isSidebarExpanded={false}
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
        onBarClick={handleBarClick}
      />

      {/* Drill-down Modal — tables driven by pagemeta */}
      <AutoResolvedDrillDownModal
        open={drillDownOpen}
        onClose={() => setDrillDownOpen(false)}
        selectedDataPoint={selectedDataPoint}
        chartTitle={title}
        startDate={drillDownDates.startDate || startDate}
        endDate={drillDownDates.endDate || endDate}
        globalFilters={globalFilters}
      />
    </Box>
  );
};

export default AutoResolvedChart;
